import { SvgIcon } from '@mui/material';
const DairyIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
      >
        <path d="M4.45 6.981H1v6.5h14.1v-1.25" stroke="currentColor" />
        <path d="M15.1 8.481v-1.5H4.3" stroke="currentColor" />
        <path
          d="m15.1 6.982-7.25-3.45a4.9 4.9 0 0 0-6 1.25 3.5 3.5 0 0 0-.85 2.2m4.05 5a1.6 1.6 0 1 0 0-3.2 1.6 1.6 0 0 0 0 3.2Zm4.95-.55a1.05 1.05 0 1 0 0-2.1 1.05 1.05 0 0 0 0 2.1Zm5.1.8a1.898 1.898 0 0 1-2.032-2.673A1.9 1.9 0 0 1 15.1 8.482"
          stroke="currentColor"
        />
      </svg>
    </SvgIcon>
  );
};

export default DairyIcon;
